/**
 * @desc 推送消息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.SystemMessagePagingQueryConditions>): Promise<BaseResponse<defs.PageBean<Array<defs.SysMsgEntityObject>>>> {
  return fetch({
    url: config.API_HOST + '/station/sendStationInfo',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
